// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/PayoutDetail.jsx (enterprise kit redesign).
 * Loaded AFTER index.css and enterprise.css (and after the page's own inline
 * \\3c style>) so equal-specificity rules here win by source order.
 *
 * Breakpoints (project standard):
 *   mobile  : <=576px
 *   tablet  : 577–991px
 *   laptop  : 992–1280px
 *   desktop : >=1281px
 *
 * The on-chain transaction table uses the kit's \`.pro-table\`, which already
 * converts to stacked label/value cards at <=576px (see enterprise.css), and
 * every data cell carries a data-label. The header actions stack full-width via
 * enterprise.css \`.ent-page-head__actions\`. These overrides only fix the
 * page-specific breadcrumb back-button tap target and breadcrumb wrapping.
 */

/* ===========================================================================
 * MOBILE (<=576px)
 * ======================================================================== */
@media (max-width: 576px) {

  /* ---- Breadcrumb: 44px tap target for the back button ---- */
  .payout-detail-page .back-btn {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
  }

  /* ---- Breadcrumb: wrap instead of overflowing ---- */
  .payout-detail-page .payout-breadcrumb-bar {
    flex-wrap: wrap;
    gap: 0.375rem;
    margin-bottom: 0.75rem;
  }

  /* Truncate long request IDs in the breadcrumb */
  .payout-detail-page .breadcrumb-current {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100vw - 160px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/PayoutDetail.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;EAgBE;;AAEF;;6EAE6E;AAC7E;;EAEE,8DAA8D;EAC9D;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA,sDAAsD;EACtD;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;;EAEA,gDAAgD;EAChD;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;EAChC;AACF","sourcesContent":["/*\n * Responsive overrides for src/pages/PayoutDetail.jsx (enterprise kit redesign).\n * Loaded AFTER index.css and enterprise.css (and after the page's own inline\n * <style>) so equal-specificity rules here win by source order.\n *\n * Breakpoints (project standard):\n *   mobile  : <=576px\n *   tablet  : 577–991px\n *   laptop  : 992–1280px\n *   desktop : >=1281px\n *\n * The on-chain transaction table uses the kit's `.pro-table`, which already\n * converts to stacked label/value cards at <=576px (see enterprise.css), and\n * every data cell carries a data-label. The header actions stack full-width via\n * enterprise.css `.ent-page-head__actions`. These overrides only fix the\n * page-specific breadcrumb back-button tap target and breadcrumb wrapping.\n */\n\n/* ===========================================================================\n * MOBILE (<=576px)\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* ---- Breadcrumb: 44px tap target for the back button ---- */\n  .payout-detail-page .back-btn {\n    width: 44px;\n    height: 44px;\n    flex-shrink: 0;\n  }\n\n  /* ---- Breadcrumb: wrap instead of overflowing ---- */\n  .payout-detail-page .payout-breadcrumb-bar {\n    flex-wrap: wrap;\n    gap: 0.375rem;\n    margin-bottom: 0.75rem;\n  }\n\n  /* Truncate long request IDs in the breadcrumb */\n  .payout-detail-page .breadcrumb-current {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: calc(100vw - 160px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
